import React, { useEffect, useRef, useState } from 'react';
import { useBattle } from '../context/BattleProvider';

export const BattleChat: React.FC = () => {
  const { chatMessages, sendChat, session } = useBattle();
  const [input, setInput] = useState('');
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatMessages]);

  const handleSend = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = input.trim();
    if (!trimmed || !session) return;
    setInput('');
    await sendChat(trimmed);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <p className="section-label" style={{ padding: '0 12px', marginTop: 12 }}>
        Live chat
      </p>

      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '8px 12px',
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        {chatMessages.map((msg) => (
          <div key={msg.id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
            {msg.avatar_url ? (
              <img
                src={msg.avatar_url}
                alt={msg.username}
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: '50%',
                  flexShrink: 0,
                  objectFit: 'cover',
                  border: '1px solid var(--border)',
                }}
              />
            ) : (
              <div
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: '50%',
                  background: 'var(--accent-dim)',
                  flexShrink: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 11,
                  color: 'var(--accent)',
                  fontWeight: 600,
                }}
              >
                {msg.username[0]?.toUpperCase()}
              </div>
            )}
            <div>
              <span
                style={{ fontSize: 11, fontWeight: 600, color: 'var(--accent)', marginRight: 6 }}
              >
                {msg.username}
              </span>
              <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{msg.message}</span>
            </div>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      <form
        onSubmit={handleSend}
        style={{
          display: 'flex',
          gap: 8,
          padding: '10px 12px',
          borderTop: '1px solid var(--border-subtle)',
        }}
      >
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Say something…"
          style={{ flex: 1, fontSize: 13, padding: '8px 12px' }}
        />
        <button type="submit" className="btn-primary" style={{ padding: '8px 16px', fontSize: 13 }}>
          Send
        </button>
      </form>
    </div>
  );
};
